export type UseGoogleTagServicesProps = {
  enabled: boolean;
}

export function useGoogleTagServices({ enabled }: UseGoogleTagServicesProps) {
  if (!enabled) {
    return <></>
  }

  return (
    <>
      <script key='google-tag-services' async type='text/javascript' src='https://securepubads.g.doubleclick.net/tag/js/gpt.js' />
    </>
  )
}